// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_MESSAGE_YOU_GAVE_REVIEW_LINK_LABEL = "hodnocen\u00ed";
export const BZ2_MESSAGE_YOU_GAVE_REVIEW_TO_link = "P\u0159idala jsi %(link)s";
export const BZ2_MESSAGE_YOU_GOT_REVIEW_FROM_link = "ti p\u0159idala %(link)s";
export const BZ2_MESSAGE_YOU_GOT_REVIEW_LINK_LABEL = "hodnocen\u00ed";
